'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withButtonHeight = exports.buttonHeightNumber = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['height: ', ';'], ['height: ', ';']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n    ', '\n  '], ['\n    ', '\n  ']);
var _styledComponents = require('styled-components');
var _unit = require('./unit');
var _unit2 = _interopRequireDefault(_unit);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var buttonHeightNumber = exports.buttonHeightNumber = function buttonHeightNumber(size) {
  var sizes = {
    extraLarge: 64,
    large: 48,
    medium: 40,
    small: 32
  };
  return sizes[size];
};
var withButtonHeight = exports.withButtonHeight = function withButtonHeight(_ref) {
  var size = _ref.size;
  return (0, _styledComponents.css)(_templateObject, buttonHeightNumber(size) + _unit2.default);
};
exports.default = function () {
  return (0, _styledComponents.css)(_templateObject2, withButtonHeight);
};